import { CheckoutReviewAndSubmitState } from "@iewccouk/Store/State/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitState";
import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CartLineModel, PaymentMethodDto } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: CheckoutReviewAndSubmitState = {
    onCalendar: false,
    estimateShipDateOrderChanged: false,
    cartEstimateShipDate: "",
    cartLines: [],
    paymentMethod: undefined,
};

const customCheckoutReviewAndSubmitReducer = {
    "Custom/CheckoutReviewAndSubmit/ShippingDetails": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {
            onCalendar: boolean;
        },
    ) => {
        draft.onCalendar = action.onCalendar;
    },
    "Custom/CheckoutReviewAndSubmit/EstimateShipDateOrderChanged": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {
            estimateShipDateOrderChanged: boolean;
        },
    ) => {
        draft.estimateShipDateOrderChanged = action.estimateShipDateOrderChanged;
    },
    "Custom/CheckoutReviewAndSubmit/CartEstimateShipDateOrderChanged": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {
            cartEstimateShipDate: string;
        },
    ) => {
        draft.cartEstimateShipDate = action.cartEstimateShipDate;
    },

    "Custom/CheckoutReviewAndSubmit/SetCartLineEstimateShip": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {
            cartLines: [];
        },
    ) => {
        draft.cartLines = action.cartLines;
    },

    "Custom/CheckoutReviewAndSubmit/ResetState": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {
            onCalendar: boolean;
            estimateShipDateOrderChanged: boolean;
            cartLines: [];
            cartEstimateShipDate: string;
        },
    ) => {
        draft.onCalendar = action.onCalendar ?? false;
        draft.estimateShipDateOrderChanged = action.estimateShipDateOrderChanged ?? false;
        draft.cartLines = action.cartLines ?? [];
        draft.cartEstimateShipDate = action.cartEstimateShipDate ?? "";
        draft.paymentMethod = undefined;
    },

    "Custom/CheckoutReviewAndSubmit/PaymentMethodChanged": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {
            paymentMethod: PaymentMethodDto;
        },
    ) => {
        draft.paymentMethod = action.paymentMethod;
    },
};

export default createTypedReducerWithImmer(initialState, customCheckoutReviewAndSubmitReducer);
